import { useFinanceiroObrasFiltros } from "./use-financeiro-obras-filtros";
import { FinanceiroObrasFiltrosView } from "./view-financeiro-obras-filtros";
import type { FinanceiroObrasFiltrosProps } from "./types-financeiro-obras-filtros";

export function FinanceiroObrasFiltros(props: FinanceiroObrasFiltrosProps) {
  const vm = useFinanceiroObrasFiltros(props);
  return <FinanceiroObrasFiltrosView {...vm} />;
}

export type * from "./types-financeiro-obras-filtros";
